import React from 'react';
import { FormatHelper } from '../../../helpers/FormatHelper';
import { ExternalLink } from '../../ExternalLink/ExternalLink';
import { DropdownButton, DropdownButtonColor } from '../../DropdownButton/DropdownButton';
import { IFlexColumnListItemOptionGroup } from './IFlexColumnListItemOptionGroup';
import { IFlexColumnListItem } from './IFlexColumnListItem';
import { ColumnRow, ColumnRowValueWithMaxHeight, ColumnRowValueWithoutMaxHeight, ContainerRow } from './styles';

interface IFlexColumnListRowProps {
  name: string;
  columns: IFlexColumnListItem[];
  values?: any[];
  optionGroups?: IFlexColumnListItemOptionGroup[];
  loading?: boolean;
}

export const FlexColumnListRow: React.FC<IFlexColumnListRowProps> = ({
  name,
  columns,
  values,
  optionGroups,
  loading
}) => {

  return (
    <>
      {values?.map((value, vindex) => {
        const rowDataKey = `${name}_row_${vindex}`;
        return (
          <ContainerRow key={rowDataKey} data-key={rowDataKey} data-class='FlexColumnListRow'>
            {columns?.map(column => {
              if (column.field === '_') return null;
              const columnDataKey = `${rowDataKey}_${column.field}`;
              return (
                <ColumnRow key={columnDataKey} data-key={columnDataKey} width={column.widthRow || column.width} textAlign={column.align}>
                  {column.maxHeight ? (
                    <ColumnRowValueWithMaxHeight maxHeight={column.maxHeight}>
                      <div>{getValue(value, column)}</div>
                    </ColumnRowValueWithMaxHeight>
                  ) : (
                    <ColumnRowValueWithoutMaxHeight>{getValue(value, column)}</ColumnRowValueWithoutMaxHeight>
                  )}
                </ColumnRow>
              );
            })}
          </ContainerRow>
        );
      })}
    </>
  );

  function getValue(row: any, column: IFlexColumnListItem) {
    if (column.type === 'options') {
      const optionGroup = optionGroups?.find(og => og.key === column.field);
      return (
        <DropdownButton
          items={(optionGroup?.rowOptions ? optionGroup.rowOptions(row) : optionGroup?.options) || []}
          defaultStyle={true}
          small={true}
          buttonColor={DropdownButtonColor.Secondary}
          text={''}
          clickItem={(key) => optionGroup && optionGroup.click && optionGroup.click(key, row)}
          disabled={loading}
        />
      );
    }

    const value = row[column.field];

    if (column.mapping && column.mapping.length > 0) {
      const mapping = column.mapping.find(m => m.key == value);
      if (mapping) {
        return mapping.value;
      }
    }

    if (column.type === 'number') {
      return value ? +value : 0;
    }

    if (!value) return '';

    if (column.type === 'date') {
      return FormatHelper.formatDate(value);
    }

    if (column.type === 'datetime') {
      return FormatHelper.formatDateTime(value);
    }

    if (column.type === 'currency') {
      return FormatHelper.formatCurrency(value);
    }

    if (column.type === 'link') {
      const lastSeparator = value.lastIndexOf('/');
      return <a href={value} target="_blank" rel="noopener noreferrer">{value.substring(lastSeparator + 1)}</a>
    }

    if (column.type === 'extenal_link') {
      return <ExternalLink link={value} />
    }

    return value;
  }
}